<template>
  <div>
    <div class="land-home-two">
      <div style="padding-top:57px">
        <el-row class="value">
          <el-col
            :span="24"
            class="valueTitle"
          >核心能力</el-col>
        </el-row>
        <div class="valueText">
          面向企业精细化管理的诉求，数字新成本解决方案以企业成本数据积累与应用的闭环打通为核心，赋能企业实现数据资产化、作业高效化、决策智能化
        </div>
      </div>

      <div class="valueImg">
        <img :src="homeValueImg" width="100%" />
      </div>
    </div>
  </div>

</template>

<script>

const staticValueUrl = require('@/assets/images/land-page/land-home/pingtai2.png')
export default {
  name: 'landHomeValue',
  data () {
    return {
      homeValueImg: staticValueUrl
    }
  }
}
</script>

<style lang="scss" scoped>
.land-home-two {
  width: 1200px;
  height:859px;
  background: #ffffff;
  margin: 0 auto 0 auto;

  //取消竖线，内容不能被选择
  -webkit-user-select: none; /*谷歌 /Chrome*/
  -moz-user-select: none; /*火狐/Firefox*/
  -ms-user-select: none; /*IE 10+*/
  user-select: none;

  .value {
    text-align: center;
    .valueTitle {
      height: 56px;
      font-size: 40px;
      font-weight: 600;
      color: #181f42;
      line-height: 56px;
      margin-bottom: 11px;
    }
  }
  .valueText {
    text-align: center;
    height: 56px;
    width: 621px;
    margin: 0 auto;
    font-size: 16px;
    font-weight: 400;
    color: #5c5c65;
    line-height: 28px;
  }
  // .valueImg {
  //   width: 1119px;
  //   height: 651px;
  //   img {
  //     width: 1119px;
  //     height: 651px;
  //   }
  // }
}
</style>
